import React from 'react';

import moment from 'moment';

import { positionFundRate } from './positionFundRate';

import Button from 'CommonComponents/Button';
import Tooltip from 'CommonComponents/Tooltip';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';

/**
 * `typeLabel`, `waitingLabel`, `hideStatus`, `rowClassName`, `outcomeChip` and
 * `titleSubLine` are OPTIONAL and ADDITIVE, for Home's unified approvals
 * register: that table names the type in a column of its own, leads with how
 * long the item has been waiting or when it was actioned, replaces the record's
 * own status with a chip for the approver's own decision, hangs a truncated
 * preview of their comment under the title, and washes an over-SLA row red.
 *
 * `outcomeChip` also SUPPRESSES the plain "Approved"/"Rejected" text in the
 * action cell — the chip already says it, and the two adjacent would read as two
 * different facts.
 */
export default function UserApprovalListPositionFundApprovalsRow(props) {
    return (
        <tr className={props.rowClassName}>
            <td onClick={props.onClickHandler} className="cursor-pointer  inbud-date-cell">
                <Tooltip
                    placement="auto-start"
                    tooltipContent={props.tooltipContent(props.row)}
                    tooltipType="table"
                    allowTooltip={props.row.approvers && props.row.approvers.length > 0}
                >
                    <div className="tw-cursor-pointer">{props.waitingLabel ?? moment(props.row.created_at).format('YY-MM-DD')}</div>
                </Tooltip>
            </td>
            {!!props.typeLabel && (
                <td onClick={props.onClickHandler} className="tw-cursor-pointer">
                    {props.typeLabel}
                </td>
            )}
            <td onClick={props.onClickHandler} className="cursor-pointer">
                <Tooltip
                    placement="auto-start"
                    tooltipContent={props.tooltipContent(props.row)}
                    tooltipType="table"
                    allowTooltip={props.row.approvers && props.row.approvers.length > 0}
                >
                    <div className="tw-cursor-pointer">
                        {props.row.position.name} {props.row.position.last_name}
                    </div>
                </Tooltip>
                {props.titleSubLine}
            </td>
            <td onClick={props.onClickHandler} className="cursor-pointer inbud-numeric-cell">
                <Tooltip
                    placement="auto-start"
                    tooltipContent={props.tooltipContent(props.row)}
                    tooltipType="table"
                    allowTooltip={props.row.approvers && props.row.approvers.length > 0}
                >
                    <div className="tw-cursor-pointer">{positionFundRate(props.row.amount_data)}</div>
                </Tooltip>
            </td>
            {!props.hideStatus && (
                <td onClick={props.onClickHandler} className="cursor-pointer">
                    <Tooltip
                        placement="auto-start"
                        tooltipContent={props.tooltipContent(props.row)}
                        tooltipType="table"
                        allowTooltip={props.row.approvers && props.row.approvers.length > 0}
                    >
                        <div className="tw-cursor-pointer">{props.row.status_label}</div>
                    </Tooltip>
                </td>
            )}
            {!!props.outcomeChip && <td>{props.outcomeChip}</td>}
            <td>
                {props.canBeToggled && props.isPending(props.row) && (
                    <small className={'pl-3'}>
                        <Button variant="success" onClick={() => props.toggle(props.row)}>
                            <CircleCheckIcon className="tw-w-3 tw-h-3 tw-mr-1" aria-hidden="true" />
                            Action
                        </Button>
                    </small>
                )}
                {/* Optional chaining, not tidiness: this row now renders on the
                    Home landing page, and with no error boundary anywhere in the
                    app a missing `common_approval_statuses` would blank the page
                    rather than one tab. */}
                {!props.outcomeChip && props.row.pivot.status === props.commonApprovalStatuses?.approved && 'Approved'}
                {!props.outcomeChip && props.row.pivot.status === props.commonApprovalStatuses?.rejected && 'Rejected'}
            </td>
        </tr>
    );
}
